export const DEFAULT_TIME_ZONE_POLICY = Object.freeze({
    mode: 'FIXED',
    fixedTimeZone: 'Asia/Seoul',
    fallbackTimeZone: 'Asia/Seoul',
});
export const DEFAULT_DISPLAY_FORMAT = 'YYYY-MM-DD HH:mm';
//# sourceMappingURL=policy.js.map